var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchBox",on:{"click":function($event){return _vm.$emit('clickHandler')}}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"si si-chevron-right search-overlay-arrow"})]),_c('div',{staticClass:"searchBoxContent"},[_vm._v(" "+_vm._s(_vm.filteredContent)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }